import { GoogleTagAnalyticsService } from '@/app/services/google-tag';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
  signal,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EFavoriteTab } from '../../models';
// import { EGoogleTagAnalyticsKeys } from '../../../enums';
// import { EMatchTap } from '../../models';

interface ITapOption {
  title: string;
  isSelected: boolean;
  value: EFavoriteTab;
}

// const matchTap = {
//   0: 'SUMMARY',
//   1: 'STATS',
//   2: 'LINEUP',
//   3: 'INFO_MATCH',
// };

@Component({
  selector: 'app-favorite-tab-bar',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './favorite-tab-bar.component.html',
  styleUrl: '../../../../styles/tab-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoriteTabBarComponent {
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);
  valueTap = output<EFavoriteTab>();

  selectedTap = signal<EFavoriteTab>(EFavoriteTab.COMPETITION);
  tapOption = computed<ITapOption[]>(
    () =>
      [
        {
          title: this.translateService.instant('MyCompetitions'),
          isSelected: true,
          value: EFavoriteTab.COMPETITION,
        },
        {
          title: this.translateService.instant('MyMatches'),
          isSelected: false,
          value: EFavoriteTab.MATCH,
        },
        {
          title: this.translateService.instant('MyTeams'),
          isSelected: false,
          value: EFavoriteTab.TEAM,
        },
        // {
        //   title: this.translateService.instant('MatchInfo'),
        //   isSelected: false,
        //   value: EFavoriteTab.INFO_MATCH,
        // },
      ].filter(Boolean) as ITapOption[]
  );

  displayedTapOptions = computed(() =>
    this.tapOption().map((item) => ({
      ...item,
      isSelected: item.value === this.selectedTap(),
    }))
  );

  constructor(private readonly translateService: TranslateService) {}

  handleSetTap = (value: EFavoriteTab) => {
    // google tag
    // this.googleTagAnalyticsService.event(
    //   EGoogleTagAnalyticsKeys.MATCH_DETAILS_MATCH_ODL_TAB,
    //   {
    //     tab: matchTap[value] ?? this.selectedTap(),
    //   }
    // );

    this.selectedTap.set(value);
    this.valueTap.emit(value);
  };
}
